import { React } from "react";
import { Col, Row } from "reactstrap";
import { Selectform } from "../../components/drop_down/Selectform";
import {formality, disableFields} from "../../components/constants/constants";
export function WritingSetting({
  handleSelectedValue,
  formData,
  data,
  Dropdownitems,
  handleInputChange,
  IsGenerating,
  isvalidTheme,
  templateView
}) {

  let hideThemeField = false;
  let hidewordsField = false;
  let hideformalField = false;
  let hidestyleField = false;

  if (data && data?.disable_fields_for_template) {
    hideThemeField = data?.disable_fields_for_template?.includes(
      disableFields.THEME
    );
    hidewordsField = data?.disable_fields_for_template?.includes(
      disableFields.SUGGESTED_WORDS
    );
    hideformalField = data?.disable_fields_for_template?.includes(
      disableFields.FORMALITY
    );
    hidestyleField = data?.disable_fields_for_template?.includes(
      disableFields.TASK_STYLE
    );
  }

  if (
    data &&
    hideThemeField &&
    hidewordsField &&
    hideformalField &&
    hidestyleField
  ) {
    return null;
  }
  if(templateView)
  {
    return (
      <Row className="g-0">
        <Col className="col-12">
          {/* {!hideThemeField &&(
          <Col className="col-12 p-2 pb-1">
            <label class="pb-2 fw-600" for="topic">
              Theme
            </label>
            <span class="custom_tooltip">
              <span class="ps-1">
              <svg width="15" height="15" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6.5" cy="6.5" r="4.875" stroke="#4A5567" stroke-width="1.625"/>
                <path d="M6.77116 4.06283C6.77116 4.2124 6.6499 4.33366 6.50033 4.33366C6.35075 4.33366 6.22949 4.2124 6.22949 4.06283C6.22949 3.91325 6.35075 3.79199 6.50033 3.79199C6.6499 3.79199 6.77116 3.91325 6.77116 4.06283Z" fill="#4A5567" stroke="#4A5567" stroke-width="0.8125"/>
                <path d="M6.5 9.20866V5.41699" stroke="#4A5567" stroke-width="1.625"/>
              </svg>
              </span>
              <span class="tooltip_content theme_tooltip">Select the theme from the dropdown, write down your own theme or leave blank and the system will generate a random theme.</span>
            </span>
            <div class="form-group md-group show-label">
              <CreatableSelect
                className={`form-select form-select-bold p-0 ${select_disabled}`}
                placeholder="Select or add theme"
                isClearable
                onChange={handleSelectedValue}
                value={{
                  label: formData.topic ? formData.topic : "Select or add theme",
                }}
                options={Dropdownitems?.student_theme_choices?.map((item) => {
                  return { value: item, label: item, name: "topic" };
                })}
                isDisabled={IsGenerating}
                isRequired={true}
              />
            </div>
            <p style={{color:"red"}}>{isvalidTheme}</p>
          </Col>
          )} */}
          {!hidewordsField &&(
          <Col className="col-12 p-2 pb-1">
              <label class="pb-2 fw-600" for="recom_words">
              Suggested number of words
              </label>
              <input
                  type="number"
                  name="recom_words"
                  class="form-control sm-form-rounded"
                  aria-describedby="recom_wordsHelp"
                  placeholder="230"
                  value={formData.recom_words}
                  onChange={handleInputChange}
                  disabled={IsGenerating}
                  required={formData?.action_value ? false : true}
              />
          </Col>
          )}
        </Col>
        <Col>
          <Col className="col-12">
            {!hideformalField &&(
            <Col className="col-12 p-2 pb-1">
              <label class="pb-2 fw-600" for="formality">
                  Formality
              </label>
              <div class="form-group md-group show-label">
                <Selectform
                  name="formality"
                  placeholder="Select formality"
                  selectedvalue={formData.formality}
                  choices={formality}
                  onChange={handleInputChange}
                  disabled={IsGenerating}
                  required={formData?.action_value ? false : true}
                />
              </div>
            </Col>
            )}
            {!hidestyleField &&(
            <Col className="col-12 p-2 pb-1">
              <label class="pb-2 fw-600" for="task_style">
                  Task style
              </label>
              <div class="form-group md-group show-label">
                <Selectform
                  name="task_style"
                  placeholder={"Select task style"}
                  selectedvalue={formData.task_style}
                  choices={Dropdownitems?.writing_style_choices}
                  onChange={handleInputChange}
                  disabled={IsGenerating}
                  required={formData?.action_value ? false : true}
                />
              </div>
            </Col>
            )}
          </Col>
        </Col>
      </Row>
    );
  }
  else
  {
    return (
      <Row className={"g-0"}>
        <Col className="col-12 sm-flex">
          {/* {!hideThemeField &&(
          <Col className="col-lg-6 col-sm-12 pt-3 pe-3">
            <label class="pb-2 fw-600" for="topic">
              Theme
            </label>
            <div class="form-group md-group show-label">
              <CreatableSelect
                className={`form-select form-select-bold p-0 ${select_disabled}`}
                placeholder="Select or add theme"
                isClearable
                onChange={handleSelectedValue}
                value={{
                  label: formData.topic ? formData.topic : "Select or add theme",
                }}
                options={Dropdownitems?.student_theme_choices?.map((item) => {
                  return { value: item, label: item, name: "topic" };
                })}
                isDisabled={IsGenerating}
                isRequired={true}
              />
            </div>
            <p style={{color:"red"}}>{isvalidTheme}</p>
          </Col>
          )} */}
          {!hidewordsField &&(
          <Col className="col-lg-6 col-sm-12 ps-1 pt-3 pe-3">
              <label class="mb-2 fw-600 form-label-text" for="recom_words">
              Suggested number of words
              </label>
              <input
                  type="number"
                  name="recom_words"
                  class="form-control sm-form-rounded"
                  aria-describedby="recom_wordsHelp"
                  placeholder="230"
                  value={formData.recom_words}
                  onChange={handleInputChange}
                  disabled={IsGenerating}
                  required
              />
          </Col>
          )}
          {!hideformalField &&(
            <Col className="col-lg-6 col-sm-12 ps-1 pt-3 pe-3">
              <label class="pb-2 fw-600" for="formality">
                  Formality
              </label>
              <div class="form-group md-group show-label">
                <Selectform
                  name="formality"
                  placeholder="Select formality"
                  selectedvalue={formData.formality}
                  choices={formality}
                  onChange={handleInputChange}
                  disabled={IsGenerating}
                  required
                />
              </div>
            </Col>
            )}
        </Col>
        <Col className="pb-3">
          <Col className="col-12 sm-flex">
            {!hidestyleField &&(
            <Col className="col-lg-6 col-sm-12 ps-1 pt-3 pe-3">
              <label class="pb-2 fw-600" for="task_style">
                  Task style
              </label>
              <div class="form-group md-group show-label">
                <Selectform
                  name="task_style"
                  placeholder={"Select task style"}
                  selectedvalue={formData.task_style}
                  choices={Dropdownitems?.writing_style_choices}
                  onChange={handleInputChange}
                  disabled={IsGenerating}
                  required
                />
              </div>
            </Col>
            )}
          </Col>
        </Col>
      </Row>
    );
  }
}
